export default __webpack_public_path__ + "static/media/Group 1773.c87a0d8b.png";